<Header 
	platformName={platform} 
>
	<div slot="skip-to-content">
		<SkipToContent />
	</div>
</Header>

<Content>

	<FluidForm>
		<Grid>

			<Row padding>
				<Column xlg={4}>

				<p>BIOMARKER CODES</p>
				<h1>Set Password</h1>
				<p style="visibility:hidden;">BIOMARKER CODES</p>

				<PasswordInput 
					id="inputPassword" 
					placeholder="New password (min 6 characters)" 
					value={newPassword}
					on:input={event => (newPassword = event.target.value)}
					required
				/>
				
				<PasswordInput 
					id="confirmPassword" 
					class="form-control" 
					placeholder="Confirm password" 
					value={confirmPassword}
					on:input={event => (confirmPassword = event.target.value)}						 
					required
				/>
			</Column>
			</Row>

			<Row padding>
				<Column xlg={4}>
					{#if errors}
						{#each errors as error}
							<p>{error}</p>
							<!-- <Alert message={error}/> -->
						{/each}
					{/if}	
				</Column>
			</Row>

			<Row padding>
				<Column xlg={1}>
					<Button 
						kind="gost" 
						disabled={skelliButton}
						icon={Erase32} 
						on:click={e=>{newPassword='';confirmPassword='';errors=[];}}
					>
						Clear
					</Button>
				</Column>
				<Column xlg={3}>
					<Button 
						class="float-right"
						disabled={!validPassword} 
						skeleton={skelliButton}
						icon={ArrowRight32}
						on:click={e=>handleResetPassword(e)}
					>
						Set password
					</Button>
				</Column>
			</Row>
		</Grid>
	</FluidForm>

</Content>

<style lang="scss" global>
  .bx--text-input {
    font-size: large;
  }
</style>

<script>
	export let location, platform 
	
	import { onDestroy } from 'svelte'
	import auth from '../../helpers/auth.js'
	
	// import Alert from './Alert.svelte'
	import { navigate, Link } from 'svelte-routing'
	import queryString from "query-string"

	import { Auth } from '../../config/firebase'

		// Native Carbon Components
	import {
    Header,
		SkipToContent,
		Content,
		PasswordInput,
		Form,
		FluidForm,
		Button,
		ButtonSet,
		Grid,
		Row,
		Column
	} from "carbon-components-svelte"
	import ArrowRight32 from "carbon-icons-svelte/lib/ArrowRight32"
	import Erase32 from "carbon-icons-svelte/lib/Erase32"

	let loading = false
  let queryParams;
	$: queryParams = queryString.parse(location.search)
	$: actionCode = queryParams.actionCode
	$: mode = queryParams.mode
	$: oobCode = queryParams.oobCode
	$: continueUrl = queryParams.continueUrl
	$: validPassword = (newPassword.length > 5 && confirmPassword == newPassword) ? true : false
	$: skelliButton = loading

	let authStore
	let unsubscribe = auth.subscribe(store => {
    	authStore = store
	})

	let errors=[]
	$: isLoggedIn = authStore.loggedIn

	let confirmPassword = ''
	let newPassword = ''
		
	onDestroy(() => {
    if (unsubscribe) {
      unsubscribe()
    }
	})

	async function handleResetPassword(e) {
		errors = []
		loading = true
		// Localize the UI to the selected language as determined by the lang
		// parameter.

		// Verify the password reset code is valid.
		await Auth.verifyPasswordResetCode(oobCode).then( async (email) => {
			// console.log(`oob code verified`)
			// TODO: Show the reset screen with the user's email and ask the user for
			// the new password.

			// Save the new password.
			await Auth.confirmPasswordReset(oobCode, newPassword).then( async (resp) => {
				// Password reset has been confirmed and new password updated.
				// console.log(`new password has been set: ${newPassword} for email ${email}`)
				// TODO: Display a link back to the app, or sign-in the user directly
				// if the page belongs to the same domain as the app:
				// auth.signInWithEmailAndPassword(accountEmail, newPassword);
				await auth.login(email, newPassword)
				loading = false
				navigate(`/`, {replace: true})
				// TODO: If a continue URL is available, display a button which on
				// click redirects the user back to the app via continueUrl with
				// additional state determined from that URL's parameters.
			}).catch(function(error) {
				// Error occurred during confirmation. The code might have expired or the
				// password is too weak.
				// console.log(`catch confirmPassword`)
				loading = false
				errors = [...errors, error.message ]
			})
		}).catch(function(error) {
			// Invalid or expired action code. Ask user to try to reset the password
			// again.
			// console.log(`catch verify oob`)
			loading = false
			errors = [...errors, error.message ]
		})
}

</script>
